import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskLegacyAutomationRedirectEditRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-automation-redirect-edit',
	path: '/projects/:projectKey/settings/automation/ruleset/:ruleId',
};
